<!-- {{this.getVisibleAdminsInBot()}}
<div>
  @for (admin of this.getVisibleAdminsInBot(); track $index; let isFirst = $first) {
    aaa <span
    class="bubble-new"
    [ngStyle]="{
        'border-color': this.strToColor(admin.adminName),
        }"
    [tooltip]="admin.adminName"
  >{{this.getAdminNameShort(admin.adminName) }}</span>
}
</div>
-->
<div class="row ">
  <!-- <div class="col-auto align-content-center text-secondary pe-0">
  <ng-container *ngIf="this.getVisibleAdminsInBot().length !== 0">
    <span i18n="@@bot-presence-online">Online:</span>
  </ng-container>
</div> -->
<div class="col align-content-center ps-1">
  <div
    [id]="this.position+'BubbleWrapper'"
    class="position-relative"
    style="height: 30px;"
    >
    &nbsp;
    @for (admin of this.getVisibleAdminsInBot(); track $index; let isFirst = $first) {
      <p
        class="d-inline-block position-absolute rounded-circle circle text-center mb-0 top-0"
        [ngStyle]="{
        'left': isFirst ? '0': 20*$index + 'px',
        'z-index': $index,
        'background-color': this.getBubbleColor($index)
      }"
        [tooltip]="admin.adminName"
        >
        <span
          class="align-middle"
          [ngStyle]="{ 'color': this.getContrastColor(this.getBubbleColor($index))}"
          style="font-size: 8pt;"
          >
          {{ this.getAdminNameShort(admin.adminName) }}
        </span>
      </p>
    }
    @if (this.getInvisibleAdminsInBot().length !== 0) {
      @if (this.getInvisibleAdminsInBot().length === 1) {
        <p
          class="d-inline-block position-absolute rounded-circle circle text-center mb-0 top-0"
        [ngStyle]="{
              'left': this.displayableBubbles === 1 ? '0': 20*this.getVisibleAdminsInBot().length + 'px',
              'z-index': this.displayableBubbles,
              'background-color': this.getBubbleColor(this.getVisibleAdminsInBot().length)
            }"
          [tooltip]="this.getInvisibleAdminName().adminName"
          >
          <span
            class="align-middle "
            [ngStyle]="{ 'color': this.getContrastColor(this.getBubbleColor(this.getVisibleAdminsInBot().length))}"
            style="font-size: 8pt;"
            >
            {{ this.getAdminNameShort(this.getInvisibleAdminName().adminName) }}
          </span>
        </p>
      }
      @else {
      <p
        class="d-inline-block position-absolute rounded-circle circle text-center mb-0 top-0"
        [ngStyle]="{
            'left': this.displayableBubbles === 0 ? '0': 20*this.getVisibleAdminsInBot().length + 'px',
            'z-index': this.displayableBubbles
          }"
        style="background-color: #b8860b;"
        [tooltip]="invisibleAdminTlp"
        >
        <span
          class="align-middle text-light"
          style="font-size: 8pt;"
          >
          @if (this.displayableBubbles !== 0) {
            +
            }{{ this.getInvisibleAdminsInBot().length
            }}
          </span>
        </p>
      }
    }
  </div>
</div>
</div>
<ng-template #invisibleAdminTlp>
  <div [innerHtml]="this.getInvisibleAdminNames()"></div>
</ng-template>
